import { PowerBiReportRenderer } from '~components/power-bi-report-renderer'
import { powerBiPoolFilterDefaults } from '../../../../constants/power-bi'
import { ReportWithToken } from '../../../../hooks/queries/reports/use-power-bi-report-with-token'

export function CiiPredictiveToolReport({
  selectedReport,
}: {
  selectedReport: ReportWithToken
}) {
  const reportFilters = {
    ...powerBiPoolFilterDefaults,
    displaySettings: { isHiddenInViewMode: false },
    target: {
      column: 'Segments',
      table: 'Insite Summary Report',
    },
  }

  return (
    <PowerBiReportRenderer
      defaultFilters={reportFilters}
      report={selectedReport}
    />
  )
}
